// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bNaE","colBig":"styles_colBig__3gPE_","colSmall":"styles_colSmall__2FymI","shopifyNameWrapper":"styles_shopifyNameWrapper__26Lr9"};